<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({name: 'Home'})"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div 
          class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 white--text primary-text" 
          :class="{'text-h6': $vuetify.breakpoint.xsOnly}"
          style="font-size: 16px;" 
        >
          {{ title }}
        </div>


        <!-- Acordeón para pantallas pequeñas -->
        <v-expansion-panels v-if="$vuetify.breakpoint.xsOnly">
          <v-expansion-panel
            v-for="(element, index) in documentos"
            :key="index"
            style="margin-bottom: 5px; border-radius: 5px; overflow: hidden;"
          >
            <v-expansion-panel-header
              style="background-color: #e0e0e0; display: flex; align-items: center; justify-content: flex-start; border-top-left-radius: 5px; border-top-right-radius: 5px;"
            >
              <div style="display: flex; align-items: center; flex: 0 0 auto; margin-right: 10px;">
                <div
                  :style="{
                    width: '15px',
                    height: '15px',
                    borderRadius: '50%',
                    backgroundColor: getStatusColor(element),
                  }"
                ></div>
              </div>

              <div style="display: flex; align-items: center; flex: 1;">
                <div style="font-size: 16px; word-wrap: break-word; word-break: break-word;">
                  {{ element.documento }}
                </div>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content
              style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;"
            >
              <div style="margin-top: 16px;">
                <strong v-if="element.entregado == true && element.validado == false" style="color:green">
                  Entregado
                </strong>
                <strong v-else-if="element.entregado == false && element.validado == false" style="color:red">
                  Faltante
                </strong>
                <br />

                <div style="margin-top: 4px;">
                  <strong v-if="element.entregado == true && element.validado == true" style="color:orange">
                    Validado
                  </strong>
                </div>

                <br />
                <div v-if="element.documentos.length > 0 && element.validado == false">
                  <v-btn-toggle v-for="(docElement, docIndex) in element.documentos" :key="docIndex" rounded class="btnUpload" style="margin-bottom: 10px;">
                    <v-btn
                      color="rgba(0, 0, 0, .5)"
                      fab
                      x-small
                      dark
                      elevation="7"
                      :title="docTitle(docIndex)"
                      width="100px"
                      style="margin-bottom: 10px;"
                    >
                      <p class="documentTitle">{{ docTitle(docIndex) }} </p>
                    </v-btn>

                    <v-btn
                      color="primary"
                      fab
                      x-small
                      dark
                      elevation="7"
                      v-on:click="examen = true"
                      v-bind:href="docElement.documento_imagen.imagen"
                      target="_blank"
                      title="Ver"
                      style="margin-bottom: 10px;"
                    >
                      <v-icon color="white">mdi-eye</v-icon>
                    </v-btn>

                    <v-btn
                      color="info"
                      fab
                      x-small
                      dark
                      elevation="7"
                      v-on:click="examen = true"
                      @click="uploadFile(docElement.documento_completo.IDF)"
                      title="Modificar"
                      style="margin-bottom: 10px;"
                    >
                      <v-icon color="white">mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      color="error"
                      fab
                      x-small
                      dark
                      elevation="7"
                      v-on:click="examen = true"
                      @click="deleteDocumento(docElement.documento_imagen.IDVReg)"
                      title="Eliminar"
                      style="margin-bottom: 10px;"
                    >
                      <v-icon color="white">mdi-delete</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </div>

                <div v-if="element.documentos.length < 2 && element.validado == false && element.id != 10">
                  <v-btn
                    v-for="btnElement in docCount(element.documentos)"
                    :key="btnElement"
                    color="success"
                    fab
                    x-small
                    dark
                    elevation="7"
                    v-on:click="examen = true"
                    @click="uploadFile(element.documento_completo.IDF)"
                    title="Subir Documento"
                    class="btnUpload"
                    style="margin-bottom: 10px;"
                  >
                    <v-icon color="white">mdi-cloud-upload</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- Tabla para pantallas grandes -->
        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Documento</th>
                <th class="text-left">Estado</th>
                <th class="text-left">Validado</th>
                <th class="text-left">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(element, index) in documentos" :key="index">
                <td>{{ element.documento }}</td>
                <td>
                  <strong v-if="element.entregado == true && element.validado == false" style="color:green">
                    Entregado
                  </strong>
                  <strong v-else-if="element.entregado == false && element.validado == false" style="color:red">
                    Faltante
                  </strong>
                </td>
                <td>
                  <strong v-if="element.entregado == true && element.validado == true" style="color:orange">
                    Validado
                  </strong>
                </td>
                <td class="accionDoc">
                  <div v-if="element.documentos.length > 0 && (element.validado == false)">
                    <v-btn-toggle 
                      v-for="(docElement, docIndex) in element.documentos" 
                      :key="docIndex"
                      rounded 
                      class="btnUpload"
                    >
                      <v-btn
                        color="rgba(0, 0, 0, .5)"
                        fab
                        x-small
                        dark
                        elevation="7"
                        :title="docTitle(docIndex)" 
                        width="100px"
                      >
                        <p class="documentTitle">{{ docTitle(docIndex) }} </p>
                      </v-btn>

                      <v-btn
                        color="primary"
                        fab
                        x-small
                        dark
                        elevation="7"
                        v-on:click="examen = true"
                        v-bind:href="docElement.documento_imagen.imagen"
                        target="_blank"
                        title="Ver"
                      >
                        <v-icon color="white">mdi-eye</v-icon>
                      </v-btn>

                      <v-btn
                        color="info"
                        fab
                        x-small
                        dark
                        elevation="7"
                        v-on:click="examen = true"
                        @click="uploadFile(docElement.documento_completo.IDF)"
                        title="Modificar"
                      >
                        <v-icon color="white">mdi-pencil</v-icon>
                      </v-btn>

                      <v-btn
                        color="error"
                        fab
                        x-small
                        dark
                        elevation="7"
                        v-on:click="examen = true"
                        @click="deleteDocumento(docElement.documento_imagen.IDVReg)"
                        title="Eliminar"
                      >
                        <v-icon color="white">mdi-delete</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </div>

                  <div v-if="element.documentos.length < 2 && (element.validado == false) && element.id!=10">
                    <v-btn 
                      v-for="btnElement in docCount(element.documentos)"
                      :key="btnElement"
                      color="success"
                      fab
                      x-small
                      dark
                      elevation="7"
                      v-on:click="examen = true"
                      @click="uploadFile(element.documento_completo.IDF)"
                      title="Subir Documento"
                      class="btnUpload"
                    >
                      <v-icon color="white">
                        mdi-cloud-upload
                      </v-icon>
                    </v-btn>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>

      <input id="file-upload" type="file" v-on:change="addDocument()" ref="fileInput" class="inputUpload" />
    </CardIeaAppMain>
  </div>
</template>


<style>
    .hideTr{
        display: none;
    }

    ::v-deep .v-expansion-panel-header > *:not(.v-expansion-panel-header__icon) {
      flex: 1 0 auto; /* Esta regla sigue aplicando el flex pero con flex-basis auto para el resto de los elementos */
    }

    /* Agregar margen entre tarjetas */
    .v-expansion-panel {
      margin-bottom: 5px; /* Separación entre tarjetas */
      border-radius: 5px; /* Redondeo general */
    }

    /* Redondeo de las esquinas superiores e inferiores */
    .v-expansion-panel-header {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }

    ::v-deep .v-expansion-panel-content {
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
</style>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Documento",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title:"Documentos faltantes",
    selected:'',
    documentos:[],  
  }),

  methods: {
    getStatusColor(element) {
      if (element.entregado && element.validado) {
        return 'orange'; // Validado
      } else if (element.entregado) {
        return 'green'; // Entregado
      } else {
        return 'red'; // Faltante
      }
    },
    async uploadFile(tipo_documento_id) {
      this.selected = tipo_documento_id;     
      this.$refs.fileInput.click()   
    },

    docTitle(index){
      return "Documento " + (index+1);
    },

    docCount(docList){
      return 2 - docList.length; //correccion aparecen dos botones de subir documentos 
    },

    async addDocument() {
      var formData = new FormData();
      formData.append('tipo_documento_id', this.selected);
      formData.append('image', this.$refs.fileInput.files[0]);

      let url = "alumno-documentos/upload";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.$refs.fileInput.value = null;
          this.loadDocumentos();
        });
    },

    async deleteDocumento(id) {
      if(confirm('¿Estas seguro de eliminar este documento?')){
        let url = "alumno-documentos/delete/" + id;
        await this.$API
          .post({
            url: url,
          }).then(() => {
            this.loadDocumentos();
          });
      }
    },
    async loadDocumentos() {
      let url = "documentos/index";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.documentos = res.documentos;
        });
    }
  },

   mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.$API
      .get({
        url: "documentos/index"
      }).then((res) => {
        this.documentos = res.documentos;
      });
  },
};
</script>
